import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import TShirts from "../pages/t-shirts/page";
import MagicDresses from "../pages/magic-dresses/page";
import Jackets from "../pages/jackets/page";
import Scarves from "../pages/scarves/page";
import MetalDrums from "../pages/metal-drums/page";
import MagicDressHowTos from "../pages/magic-dress-howtos/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/t-shirts", element: <TShirts /> },
  { path: "/magic-dresses", element: <MagicDresses /> },
  { path: "/jackets", element: <Jackets /> },
  { path: "/scarves", element: <Scarves /> },
  { path: "/metal-drums", element: <MetalDrums /> },
  { path: "/magic-dress-howtos", element: <MagicDressHowTos /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
